import React, { Component } from 'react'
import '../../styles/GlobalStyle.css'
import { db, firebase } from '../../firebase/Firebase'
//import PersonHeader from '../../login/PersonHeader'
import PersonAvatar from '../../customcomponents/PersonAvatar'
import Note from '../progressmonitoring/Note'
import IEPParagraph from '../iep/IEPParagraph'
import UIChart from '../progressmonitoring/UIChart'
import ReactToPrint from "react-to-print"
import { flattenDoc, getIDFromURL, getQueryStringParam, capitalizeFirstChar } from '../../Util'
import ColType from '../../Types'
import { Layout, Icon, Button, Checkbox, Table, Popover } from 'antd'
import CustomFooter from '../../login/CustomFooter'
const { Content } = Layout
var moment = require('moment')

class SpecialEducationCaseload extends Component {
    state = {
        isDragging: false,
        isOver: { impact: '', level: '' },
        dragFrom: { impact: '', level: '' },
        studentId: '',
        studentsInAnyImpactsObj: {},
        impacts: [
            'Processing Speed',
            'Working Memory',
            'Verbal Comprehension',
            'Fluid Reasoning',
            'Visual Spatial Reasoning',
        ],
        impactsData: {
            'Processing Speed': { '1': [], '2': [], '3': [] },
            'Working Memory': { '1': [], '2': [], '3': [] },
            'Verbal Comprehension': { '1': [], '2': [], '3': [] },
            'Fluid Reasoning': { '1': [], '2': [], '3': [] },
            'Visual Spatial Reasoning': { '1': [], '2': [], '3': [] },
        },
        init: false,
    }
    componentDidMount() {
        if (!this.props.readOnly) {
            document.title = 'Special Education Impacts - Dot It';
        }
        var teacherId = getIDFromURL(window.location);
        if (!this.state.init) {
            this.getImpactsDataFromDB();
        }
    }
    componentWillReceiveProps(nextProps) {
        if (!this.state.init) {
            this.getImpactsDataFromDB();
        }
    }
    dragStart = (e, studentId, dragFrom) => {
        if (this.props.readOnly) return;
        //console.log('dragStart', studentId, dragFrom)
        e.dataTransfer.setData('text', 'foo') // firefox needs this to do drag and drop
        setTimeout(() => this.setState({
            studentId: studentId,
            dragFrom: dragFrom,
            isDragging: true,
        })
        )
    }
    dragEnd = (e) => {
        // console.log('drag end')
        setTimeout(() => this.setState({
            isDragging: false,
            isOver: { impact: '', level: '' },
        })
        )
    }
    dragOver = (e, info) => {
        e.preventDefault()
        if (this.state.isOver &&
            this.state.isOver.impact === info.impact &&
            this.state.isOver.level === info.level
        ) return;
        //console.log('drag over', this.props, info)
        this.setState({
            isOver: info,
        })
    }
    dragExit = (e) => {
        e.preventDefault()
        if (!this.state.isOver) return
        // console.log('drag exit', this.props)
        this.setState({
            isOver: { impact: '', level: '' },
        })
    }
    drop = (e, info) => {
        e.preventDefault()
        if (this.props.readOnly) return;
        //console.log('drop', this.state, info)
        if (!this.state.studentId) return;
        let impactsData = this.state.impactsData;
        let studentExists = impactsData[info.impact][info.level].includes(this.state.studentId)
        if (studentExists) {
            this.setState({
                isOver: { impact: '', level: '' },
                studentId: '',
            });
            return;
        }
        if (this.state.dragFrom.impact && this.state.dragFrom.level) {
            // remove from old impact/level
            let oldImpact = this.state.dragFrom.impact;
            let oldLevel = this.state.dragFrom.level;
            let studentIndex = impactsData[oldImpact][oldLevel].indexOf(this.state.studentId);
            if (studentIndex > -1) {
                impactsData[oldImpact][oldLevel].splice(studentIndex, 1);
            }
        }
        impactsData[info.impact][info.level].push(this.state.studentId);
        let studentsInAnyImpactsObj = this.state.studentsInAnyImpactsObj;
        studentsInAnyImpactsObj[this.state.studentId] = true;
        this.setState({
            impactsData: impactsData,
            studentsInAnyImpactsObj: studentsInAnyImpactsObj,
            studentId: '',
            isDragging: false,
            isOver: { impact: '', level: '' },
        }, () => {
            this.saveToDB();
        });
    }
    removeStudentFromImpact = (studentId, impact, level) => {
        if (this.props.readOnly) return;
        let impactsData = this.state.impactsData
        let studentIndex = impactsData[impact][level].indexOf(studentId)
        if (studentIndex > -1) {
            impactsData[impact][level].splice(studentIndex, 1)
        }
        if (!this.studentInAnyImpact(studentId)) {
            let studentsInAnyImpactsObj = this.state.studentsInAnyImpactsObj;
            delete studentsInAnyImpactsObj[studentId];
            this.setState({
                studentsInAnyImpactsObj: studentsInAnyImpactsObj,
            });
        }
        this.setState({
            impactsData: impactsData,
        }, () => {
            this.saveToDB()
        });
    }
    studentInAnyImpact = (studentId) => {
        for (let impact of this.state.impacts) {
            for (let level of ['1', '2', '3']) {
                if (this.state.impactsData[impact][level].includes(studentId)) {
                    return true
                }
            }
        }
        return false
    }
    getImpactsDataFromDB = () => {
        if (!(this.props.teacherBaseProps &&
            this.props.teacherBaseProps.teacher &&
            this.props.teacherBaseProps.teacher.schoolId &&
            this.props.teacherBaseProps.teacher.districtId &&
            !this.state.init
        )) {
            return;
        }
        this.setState({ init: true });
        db.collection(ColType.impacts)
            .doc(this.props.teacherBaseProps.teacher.id)
            .get()
            .then((doc) => {
                if (doc.exists) {
                    const data = flattenDoc(doc);
                    // console.log('Impacts data retrieved: ', data);
                    if (data && data.impactsData) {
                        this.setState({
                            impactsData: data.impactsData,
                        }, () => {
                            // build studentsInAnyImpactsObj
                            let studentsInAnyImpactsObj = {};
                            for (let impact of this.state.impacts) {
                                for (let level of ['1', '2', '3']) {
                                    for (let studentId of this.state.impactsData[impact][level]) {
                                        studentsInAnyImpactsObj[studentId] = true;
                                    }
                                }
                            }
                            this.setState({
                                studentsInAnyImpactsObj: studentsInAnyImpactsObj,
                            });
                        });
                    }
                } else {
                    //console.log('No impacts data found');
                }
            })
            .catch((error) => {
                console.error('Error getting impacts data: ', error)
            })
    }
    saveToDB = () => {
        if (this.props.readOnly) return;
        if (!(this.props.teacherBaseProps &&
            this.props.teacherBaseProps.teacher &&
            this.props.teacherBaseProps.teacher.schoolId &&
            this.props.teacherBaseProps.teacher.districtId &&
            this.state.init
        )) {
            return;
        }
        db.collection(ColType.impacts)
            .doc(this.props.teacherBaseProps.teacher.id)
            .set({
                teacherId: this.props.teacherBaseProps.teacher.id,
                schoolId: this.props.teacherBaseProps.teacher.schoolId,
                districtId: this.props.teacherBaseProps.teacher.districtId,
                impactsData: this.state.impactsData,
                timeStamp: firebase.firestore.FieldValue.serverTimestamp(),
            }, { merge: true })
            .then(() => {
                //console.log('Impacts data saved successfully')
            })
            .catch((error) => {
                console.error('Error saving impacts data: ', error)
            })
    }
    render() {
        const readOnly = this.props.readOnly || false;
        const leftOffset = this.props.leftOffset || 0;
        const cellHeight = 200;
        const cellHeightStr = cellHeight + 'px';
        // intensity row colors: least intense -> most intense
        const levelBg = { '3': '#dcfce7', '2': '#fef9c3', '1': '#fee2e2' }; // green, yellow, red
        const dragOverBg = '#dbeafe'; // blue drag-over highlight (wins over row tint)
        const cellBorder = '#e2e8f0'; // soft interior border
        const outerBorder = '#cbd5e1'; // darker perimeter
        const lastImpactIndex = this.state.impacts.length - 1;
        return (
            <Layout>
                <Layout className="layout-header-mt">
                    <Content style={{ marginLeft: leftOffset }}>
                        <div className='flex'>
                            {!readOnly &&
                                <div
                                    className='p-2'
                                    style={{
                                        width: '300px',
                                        overflow: 'auto', overflowX: 'hidden', height: 'calc(100% - 82px)',
                                        position: 'fixed',
                                        left: leftOffset, marginTop: '0px', borderRight: '1px solid #e8eef5',
                                        background: '#fff', borderTop: '1px solid #e8eef5'
                                    }}>
                                    <div style={{ fontSize: 20, fontWeight: 800, color: '#1e293b' }}>Students</div>
                                    <div style={{ fontSize: 16, color: '#475569', marginBottom: 16, lineHeight: 1.5 }}>
                                        Drag and drop students into the grid based on their impact and impact intensity.
                                    </div>
                                    {this.props.teacherBaseProps &&
                                        this.props.teacherBaseProps.students &&
                                        this.props.teacherBaseProps.students.length > 0 &&
                                        this.props.teacherBaseProps.students.map((student, index) => {
                                            return <div
                                                key={student.id}
                                                title="Drag and drop to the table on the right"
                                                className={'mb-1 p-1 background-fff border br-4 clickable-card drag-card relative' +
                                                    (this.state.studentsInAnyImpactsObj.hasOwnProperty(student.id) ? ' background-light-green-new border-green-new' : '')
                                                }
                                                draggable
                                                onDragStart={(e) => {
                                                    this.dragStart(e, student.id,
                                                        { impact: '', level: '' }
                                                    );
                                                }}
                                                onDragEnd={this.dragEnd}
                                            >
                                                <PersonAvatar
                                                    person={student}
                                                    size={'large'}
                                                    containerClassName="font-16"
                                                    avatarClassName="font-16 font-bold mr-2"
                                                    personClassName="font-black font-16 ellipsis"
                                                    personStyle={{ maxWidth: '250px' }}
                                                />
                                                {this.state.studentsInAnyImpactsObj.hasOwnProperty(student.id) ?
                                                    <Icon type="check" className='ml-2 font-20 font-green-new absolute-tr'
                                                        style={{ top: '17px', right: '10px' }} />
                                                    : ''}
                                            </div>
                                        })}
                                </div>}
                            <div style={{ marginLeft: readOnly ? 0 : '300px' }}></div>
                            <div className="m-lr-auto mt-4 mb-4 pl-2 pr-2"
                                style={{ width: '1056px', minWidth: '1056px', maxWidth: '1056px' }}>
                                {/* Info card with the color-coding legend (width matches the 99% grid) */}
                                <div style={{ width: '99%', display: 'flex', gap: 16, alignItems: 'center', background: '#f0f7ff', border: '1px solid #cfe3ff', borderRadius: 16, padding: '18px 22px', marginBottom: 20 }}>
                                    <Icon type='appstore' style={{ fontSize: 34, color: '#2d6a9f' }} />
                                    <div>
                                        <div style={{ fontSize: 22, fontWeight: 800, color: '#1e293b', marginBottom: 2 }}>Impact grid</div>
                                        <div style={{ fontSize: 16, color: '#475569', lineHeight: 1.5 }}>
                                            {readOnly
                                                ? 'Each student sits in the column for their impact and the row for intensity. '
                                                : 'Drag each student into the column for their impact and the row for intensity. '}
                                            Rows are color-coded by intensity: <span style={{ color: '#16a34a', fontWeight: 700 }}>green</span> is least intense, <span style={{ color: '#ca8a04', fontWeight: 700 }}>yellow</span> is moderate, and <span style={{ color: '#dc2626', fontWeight: 700 }}>red</span> is most intense.
                                        </div>
                                    </div>
                                </div>
                                <div className='flex'>
                                    <div className='w-100 flex'>
                                        <div style={{ width: '16.5%' }}>
                                            <div style={{ height: '80px', maxHeight: '80px' }}></div>
                                            <div className='border-left br-tl-15 border-top text-center' style={{ height: cellHeightStr, maxHeight: cellHeightStr, background: levelBg['3'], borderColor: cellBorder, borderLeftColor: outerBorder, borderTopColor: outerBorder }}>
                                                <div className='font-16 font-bold mb-0' style={{ marginTop: '75px', color: '#1e293b' }}>Level 3</div>
                                                <div className='font-16' style={{ color: '#475569' }}>Least Intense</div>
                                            </div>
                                            <div className='border-left border-top text-center' style={{ height: cellHeightStr, maxHeight: cellHeightStr, background: levelBg['2'], borderColor: cellBorder, borderLeftColor: outerBorder }}>
                                                <div className='font-16 font-bold mb-0' style={{ marginTop: '85px', color: '#1e293b' }}>Level 2</div>
                                            </div>
                                            <div className='border-left br-bl-15 border-top border-bottom text-center' style={{ height: cellHeightStr, maxHeight: cellHeightStr, background: levelBg['1'], borderColor: cellBorder, borderLeftColor: outerBorder, borderBottomColor: outerBorder }}>
                                                <div className='font-16 font-bold mb-0' style={{ marginTop: '75px', color: '#1e293b' }}>Level 1</div>
                                                <div className='font-16' style={{ color: '#475569' }}>Most Intense</div>
                                            </div>
                                        </div>
                                        {this.state.impacts.map((impact, index) => {
                                            const isLast = index == lastImpactIndex;
                                            return <div key={'impact-' + index} style={{ width: '16.5%' }}>
                                                <div className={'border-left border-top' +
                                                    (index === 0 ? ' br-tl-15' : '') +
                                                    (isLast ? ' border-right br-tr-15' : '') + ' p-2 pl-3 pr-3 font-16 font-bold mb-0 flex flex-h-center w-100'}
                                                    style={{ height: '80px', maxHeight: '80px', background: '#f8fafc', color: '#1e293b', borderColor: cellBorder, borderTopColor: outerBorder, ...(isLast ? { borderRightColor: outerBorder } : {}) }}>
                                                    {impact}
                                                </div>
                                                {['3', '2', '1'].map((level, levelIndex) => {
                                                    const isOverCell = this.state.isOver.impact === impact && this.state.isOver.level === level
                                                    const cellBg = isOverCell ? dragOverBg : levelBg[level]
                                                    return <div key={impact + '-' + level} className={'border-left border-top' +
                                                        (level === '1' ? ' border-bottom' : '') +
                                                        (isLast && level === '1' ? ' br-br-15' : '') +
                                                        (isLast ? ' border-right' : '') +
                                                        ' p-2 overflow-y-auto'
                                                    }
                                                        style={{
                                                            height: cellHeightStr, maxHeight: cellHeightStr, background: cellBg, borderColor: cellBorder,
                                                            ...(level === '1' ? { borderBottomColor: outerBorder } : {}),
                                                            ...(isLast ? { borderRightColor: outerBorder } : {}),
                                                        }}
                                                        onDrop={readOnly ? undefined : (e) => { this.drop(e, { impact: impact, level: level }); }}
                                                        onDragOver={readOnly ? undefined : (e) => { this.dragOver(e, { impact: impact, level: level }); }}
                                                        onDragLeave={readOnly ? undefined : this.dragExit}>
                                                        {this.state.impactsData[impact][level].map((studentId, idx) => {
                                                            let student = null;
                                                            if (this.props.teacherBaseProps &&
                                                                this.props.teacherBaseProps.studentDict &&
                                                                this.props.teacherBaseProps.studentDict.hasOwnProperty(studentId)) {
                                                                student = this.props.teacherBaseProps.studentDict[studentId];
                                                            }
                                                            if (!student) return null;
                                                            return <Popover
                                                                key={student.id + '-' + impact + '-' + level}
                                                                overlayClassName='popover-no-pointer-events'
                                                                defaultVisible={this.state.isDragging ? false : undefined}
                                                                mouseEnterDelay={0.5}
                                                                content={
                                                                    <div className='pointer-events-none'>
                                                                        <PersonAvatar
                                                                            person={student}
                                                                            containerClassName="font-16"
                                                                            avatarClassName="font-16 font-bold mr-05"
                                                                            personClassName="font-black font-16 ellipsis"
                                                                            personStyle={{ maxWidth: '400px' }}
                                                                        />
                                                                    </div>
                                                                }>
                                                                <div
                                                                    className={'mb-1 p-1 border br-4 flex flex-v-center relative background-fff' +
                                                                        (readOnly ? '' : ' cursor-pointer') +
                                                                        (this.state.isDragging ? ' pointer-events-none' : '')}
                                                                    draggable={!readOnly}
                                                                    onDragStart={readOnly ? undefined : (e) => {
                                                                        this.dragStart(e, student.id,
                                                                            { impact: impact, level: level }
                                                                        );
                                                                    }}
                                                                    onDragEnd={readOnly ? undefined : this.dragEnd}
                                                                >
                                                                    <PersonAvatar
                                                                        person={student}
                                                                        size={'small'}
                                                                        containerClassName="font-12"
                                                                        avatarClassName="font-10 font-bold mr-05"
                                                                        personClassName="font-black font-12 ellipsis"
                                                                        personStyle={{ maxWidth: '75px' }}
                                                                    />
                                                                    {readOnly ? null : <Icon type="close" className='ml-auto cursor-pointer absolute-tr font-12'
                                                                        style={{ top: '4px', right: '4px' }}
                                                                        onClick={() => { this.removeStudentFromImpact(student.id, impact, level); }} />}
                                                                </div>
                                                            </Popover>
                                                        })}
                                                    </div>
                                                })}
                                            </div>
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='mt-100' style={{ marginLeft: readOnly ? 0 : '300px' }}>
                            <CustomFooter />
                        </div>
                    </Content>
                </Layout>
            </Layout>
        )
    }
}
export default SpecialEducationCaseload